import axios from 'axios'
import { gengetURLTEST, genURL } from "../../_getjson";

export default async function Chacktaxgroup(code, tablename) {
    if (code) {
        var rs = []
        var Url = ""
        if (tablename === "CSTAXGROUP") {
            Url = "CSTAXGROUP/Gettaxgtoup?Data=" + code
        }
        console.log(genURL(Url));
        await axios.get(genURL(Url), { timeout: 3600 }).then((res) => {
            for (let i = 0; i < res.data.length; i++) {
                if (i === 0) {
                    rs[i] = {
                        MYNAMETH: res.data[i].MYNAMETH,
                        TAXGROUP: res.data[i].TAXGROUP,
                        TAXFORMAT: res.data[i].TAXFORMAT
                    }
                }
            }
        }).catch((err) => {
            console.log(err);
        });
        return rs
    }
};